export const UXFB_USER_SESSION_COUNTER_COOKIE = 'uxfb_user_sessions_count';

export const MAX_USER_SESSIONS_COUNT_FOR_UXFB = 2;
